import { ICopyFolhaPagamentoUseCase } from "../../../presentation/useCases/create/copy_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CopyFolhaPagamentoUseCase
 */

export class CopyFolhaPagamentoUseCase implements ICopyFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async copyFolhaPagamento(
    idFolhaPagamento: number,
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string | null,
  ): Promise<void> {
    await this.repository.copyFolhaPagamento(
      idFolhaPagamento,
      dataCadastro,
      dataPagamento,
      descricao ?? '',
    );
  }
}
